const state = {
    isAddingFolder: false,
    isShowingDetails: false,
    game: false,
  };
  
  const mutations = {
    setIsAddingFolder(state, isAdding) {
      state.isAddingFolder = isAdding;
    },
    setShowingDetails(state, isShowing) {
      state.isShowingDetails = isShowing;
    },
    setGame(state, newGame) {
      state.game = newGame;
    },
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
  };
  